module.exports = __webpack_public_path__ + "media/images/favicon-13889a040adecbc4ece9588894b8e30b.ico";